// Is the signed-in user in the tenant's PILOTS GROUP? (Mustang H172.)
//
// "The Pilots group" is F&D's CREW — the one the crew pickers list (H74,
// `useFdCrew` → `GET /v6/flightduty/crew`). The server names it in ONE place,
// aeronet-fast-api/app/flightduty/crud.py::crew_group_names: config
// `flightduty_usergroup`, a comma list of group NAMES, matched case-insensitively
// (legacy's MySQL collation), blank or absent → the legacy default "pilots".
// This mirrors that rule against the user's own `groups` (`/v6/users/me`), the
// way `isFlightAdminFor` mirrors access.py — so no group id is hard-coded, a
// tenant that names another crew group is read as such, and a tenant with no
// such group has no members.
//
// The config arrives from `useConfig("flightduty")` with its key prefix
// stripped (`usergroup`) and a comma value already split into a list
// (app/config/schemas.py validators), so both shapes are read here.

/** Legacy `whcfgvar function="flightduty" variable="usergroup" value="pilots"`. */
export const DEFAULT_CREW_GROUP = "pilots";

/** The crew group NAMES, lower-cased — crud.crew_group_names, client side. */
export function crewGroupNamesFor(
  dutyConfig: { [key: string]: any } | undefined | null
): string[] {
  const raw = dutyConfig?.usergroup;
  const parts: unknown[] = Array.isArray(raw)
    ? raw
    : typeof raw === "string"
    ? raw.split(",")
    : [];
  const names = parts
    .filter((p): p is string => typeof p === "string")
    .map((p) => p.trim().toLowerCase())
    .filter(Boolean);
  return names.length ? names : [DEFAULT_CREW_GROUP];
}

/** Does `currentUser` belong to a crew group? No groups on the wire is no. */
export function isInCrewGroupFor(
  currentUser: { [key: string]: any } | undefined | null,
  dutyConfig: { [key: string]: any } | undefined | null
): boolean {
  const groups = currentUser?.groups;
  if (!Array.isArray(groups) || groups.length === 0) return false;
  const crew = new Set(crewGroupNamesFor(dutyConfig));
  return groups.some(
    (g) => typeof g?.name === "string" && crew.has(g.name.trim().toLowerCase())
  );
}
